import { motion } from 'motion/react';

import { easeOutSmooth, ShimmerText, useDialog } from '@components/primitives';

import { UpgradeModal } from '@components/features/Upgrade/UpgradeCheckout/UpgradeModal';
import { useTeamQuery } from '@queries/team';

import css from './styles.module.css';

export interface UpgradeProButtonProps {
  teamUuid: string;
}

export function UpgradeProButton({ teamUuid }: UpgradeProButtonProps) {
  const { data: team } = useTeamQuery(teamUuid);

  const shouldUpgrade = team?.tier === 'free';

  const state = useDialog();

  if (!shouldUpgrade) return null;

  return (
    <UpgradeModal
      teamUuid={teamUuid}
      state={state}
      trigger={
        <motion.button
          className={css.button}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: easeOutSmooth }}
        >
          <ShimmerText className={css.label}>Upgrade</ShimmerText>
        </motion.button>
      }
    />
  );
}
